export default __webpack_public_path__ + "static/media/sass.36e863bf.png";